import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    .empty {
        text-align: center;
    }
`;
export default Wrapper;
